const state = () => ({
    authenticated: null, // null | true | false
})

const getters = {
    isAuthenticated: (state) => state.authenticated,
}

const mutations = {
    setAuthenticated(state, value) {
        state.authenticated = value
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}